// extracted by mini-css-extract-plugin
module.exports = {"container":"bb-logo_container__eV9fp"};